<div class="td-wb-notification__inner"
     role="region"
     [attr.aria-labelledby]="id"
     [class.td-wb-notification__inner--with-close]="closeButton()">
  @if(showIcon()) {
    <ng-container [ngTemplateOutlet]="customIcon() ? customIconTemplate : defaultIconTemplate" />
  }
  @if (closeButton()) {
    <div class="td-wb-notification__close-button">
      <ng-content select="td-wb-notification-close-button" />
    </div>
  }
  @if (isFocusOnInit()) {
    <td-wb-focus-anchor />
  }
  <div class="td-wb-notification__message"
       role="alert">
    @if (header()) {
      <div>
        <ng-content select="td-wb-notification-header" />
      </div>
    }
    <ng-content />
  </div>
</div>

<ng-template #defaultIconTemplate>
  <td-wb-icon class="td-wb-notification__icon"
              [iconId]="iconId()"
              [size]="notificationType() === 'note' ? '18' : '24'" />
</ng-template>

<ng-template #customIconTemplate>
  <div class="td-wb-notification__icon">
    <ng-content select="[tdWbNotificationIcon]" />
  </div>
</ng-template>